export default "__VITE_ASSET__DD$ihpA$__"